import React from 'react';
import { useParams } from 'react-router-dom';
import CampaignMasterForm from './CampaignMasterForm';

const CampaignMasterEdit = () => {
  const { id } = useParams();

  return <CampaignMasterForm id={id} />;
};

export default CampaignMasterEdit;
